import { createAction } from "redux-actions";

export const TOGGLE_ADVANCED_SEARCH = "TOGGLE_ADVANCED_SEARCH";
export const toggleAdvancedSearch = createAction(TOGGLE_ADVANCED_SEARCH);
